export default function noop() {}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-geo/src/noop.js
// module id = 12
// module chunks = 0 1 2 3 4